type SidebarKey = 'dashboard' | 'moderation' | 'locations' | 'events' | 'routes' | 'news' | 'dictionaries' | 'users';

const navItemClass = (active: boolean): string =>
  active
    ? 'flex items-center gap-3 px-3 py-2.5 rounded-lg bg-primary text-white shadow-sm shadow-primary/30'
    : 'flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors';

export const renderLocationSidebar = (active: SidebarKey = 'locations'): string => `
<aside class="fixed left-0 top-0 h-full w-64 bg-white border-r border-slate-200 flex flex-col z-50">
  <div class="p-6 flex items-center gap-3">
    <div class="bg-primary size-10 rounded-lg flex items-center justify-center text-white">
      <span class="material-symbols-outlined">motorcycle</span>
    </div>
    <div>
      <h1 class="text-slate-900 text-base font-bold leading-none">MotoJourney</h1>
      <p class="text-slate-500 text-[10px] uppercase tracking-wider mt-1 font-semibold">Admin Console</p>
    </div>
  </div>

  <nav class="flex-1 px-4 py-2 space-y-1 overflow-y-auto">
    <a class="${navItemClass(active === 'dashboard')}" href="/dashboard">
      <span class="material-symbols-outlined text-[22px]">dashboard</span>
      <span class="text-sm font-medium">Dashboard</span>
    </a>
    <a class="${navItemClass(active === 'moderation')}" href="/moderation">
      <span class="material-symbols-outlined text-[22px]">verified_user</span>
      <span class="text-sm font-medium">Moderation</span>
    </a>
    <a class="${navItemClass(active === 'locations')}" href="/locations">
      <span class="material-symbols-outlined text-[22px]">location_on</span>
      <span class="text-sm font-medium">Locations</span>
    </a>
    <a class="${navItemClass(active === 'events')}" href="/events">
      <span class="material-symbols-outlined text-[22px]">calendar_today</span>
      <span class="text-sm font-medium">Events</span>
    </a>
    <a class="${navItemClass(active === 'routes')}" href="/routes">
      <span class="material-symbols-outlined text-[22px]">route</span>
      <span class="text-sm font-medium">Routes</span>
    </a>
    <a class="${navItemClass(active === 'news')}" href="/news">
      <span class="material-symbols-outlined text-[22px]">newspaper</span>
      <span class="text-sm font-medium">News</span>
    </a>
    <a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dashboard">
      <span class="material-symbols-outlined text-[22px]">notifications</span>
      <span class="text-sm font-medium">Notifications</span>
    </a>
    <a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/locations/ai-create">
      <span class="material-symbols-outlined text-[22px]">auto_awesome</span>
      <span class="text-sm font-medium">AI Assistant</span>
    </a>

    <div class="pt-4 pb-2 px-3">
      <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Management</p>
    </div>
    <a class="${navItemClass(active === 'dictionaries')}" href="/dictionaries">
      <span class="material-symbols-outlined text-[22px]">book</span>
      <span class="text-sm font-medium">Dictionaries</span>
    </a>
    <a class="${navItemClass(active === 'users')}" href="/users">
      <span class="material-symbols-outlined text-[22px]">group</span>
      <span class="text-sm font-medium">Users</span>
    </a>
    <a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dashboard">
      <span class="material-symbols-outlined text-[22px]">settings</span>
      <span class="text-sm font-medium">Settings</span>
    </a>
  </nav>

  <div class="p-4 border-t border-slate-200">
    <div class="flex items-center gap-3 p-2 rounded-xl bg-slate-50 border border-slate-200">
      <div class="size-10 rounded-full bg-slate-200"></div>
      <div class="flex flex-col min-w-0">
        <p class="text-sm font-semibold text-slate-900 truncate">Admin User</p>
        <p class="text-xs text-slate-500 truncate">Admin</p>
      </div>
    </div>
  </div>
</aside>
`;

export const LOCATION_SIDEBAR = renderLocationSidebar('locations');
